module.exports = __webpack_public_path__ + "static/media/img_tarotcard.af06435d.png";